"use strict";
/*!
 *
 * app.js
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*** node_modules **/
require("jquery.easing");
require("slick-carousel");
/*** ./modules **/
var hasher_1 = __importDefault(require("hasher"));
var linker_1 = __importDefault(require("linker"));
var slide_scroll_1 = __importDefault(require("slide-scroll"));
var tel_handler_1 = __importDefault(require("tel-handler"));
var nav_current_1 = __importDefault(require("nav-current"));
require("fit-image");
require("swipe-elem");
require("toggler");
require("expander");
require("toggle-expander");
var local_menu_1 = __importDefault(require("local-menu"));
var stickyer_1 = __importDefault(require("stickyer"));
var switch_fontsize_1 = __importDefault(require("switch-fontsize"));
require("swipe-elem");
var top_bg_1 = __importDefault(require("top-bg"));
hasher_1.default();
$(function () {
    new nav_current_1.default('#Global');
    new nav_current_1.default('#Local', {
        abs: true
    });
    new linker_1.default({
        icon: {
            blank: 'sw-Blank',
            excel: 'sw-Xls',
            word: 'sw-Doc',
            pdf: 'sw-Pdf'
        }
    });
    tel_handler_1.default();
    slide_scroll_1.default({
        easing: 'easeOutExpo',
        speed: 700,
        not: '.sw-NotScroll, #MenuBtn, .st-Assist_Item_Link, .mc-Tab_List_Item_Link, .mc-Accordion dt a'
    });
    new switch_fontsize_1.default({
        btn: ".st-FontSize_List_Btn"
    });
    $('.st-Menu_Widget_FontSize, .st-Menu_Widget_Search').toggleExpander();
    $('#Header').toggler({
        head: '#MenuBtn',
        body: '#Menu'
    });
    new local_menu_1.default('#Local');
    new stickyer_1.default();
    new stickyer_1.default({
        limitElem: '#Contents',
        stateClass: 'shrink'
    });
    new stickyer_1.default({
        fixedElem: '#Page2Top',
        limitElem: '#Contents',
        stateClass: 'visible'
    });
    $('.mc-Swipe, .med-Doctor').swipeElem({
        width: 700
    });
    $('.cost-Table').swipeElem({
        width: 830
    });
    if ($('.tp-Contents').length) {
        new top_bg_1.default();
        $('#topMainvis').slick({
            arrows: false,
            dots: true,
            autoplay: true
        });
    }
    ;
    if (('#topSlider').length) {
        $('#topSlider').slick({
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: false,
            dots: true,
            infinite: true,
            slidesToShow: 5,
            responsive: [{
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3
                    }
                }, {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 2
                    }
                }, {
                    breakpoint: 400,
                    settings: {
                        slidesToShow: 1
                    }
                }],
            prevArrow: '<button type="button" class="slick-prev" title="前へ"></button>',
            nextArrow: '<button type="button" class="slick-next" title="次へ"></button>'
        });
    }
    ;
});
